import { createAsyncThunk } from '@reduxjs/toolkit';
import focusBearApi from 'services/axios-config';
import Endpoints from 'constants/endpoints';
import { PORTFOLIO_I18N_KEYS } from 'constants/project';
import { HTTP_STATS_CODE } from 'constants/general';
import { toast } from 'react-toastify';
import { t } from 'services/i18n.service';
import { captureException } from 'services/posthog.service';
import {
  PortfolioForecastResponse,
  PortfolioResponse,
  PortfolioSettings
} from 'interfaces/project.interface';

export const fetchPortfolio = createAsyncThunk(
  'portfolio/fetch_portfolio',
  async () => {
    try {
      const { data } = await focusBearApi.get<PortfolioResponse>(
        Endpoints.PORTFOLIO
      );
      return data;
    } catch (error) {
      captureException(JSON.stringify(error));
      return null;
    }
  }
);

export const fetchPortfolioForecast = createAsyncThunk(
  'portfolio/fetch_forecast',
  async () => {
    try {
      const { data } = await focusBearApi.get<PortfolioForecastResponse>(
        Endpoints.PORTFOLIO_FORECAST
      );
      return data;
    } catch (error) {
      captureException(JSON.stringify(error));
      return null;
    }
  }
);

export const fetchPortfolioSettings = createAsyncThunk(
  'portfolio/fetch_settings',
  async () => {
    try {
      const { data } = await focusBearApi.get<PortfolioSettings>(
        Endpoints.PORTFOLIO_SETTINGS
      );
      return data;
    } catch (error) {
      captureException(JSON.stringify(error));
      return null;
    }
  }
);

export const updatePortfolioSettings = createAsyncThunk(
  'portfolio/update_settings',
  async (payload: PortfolioSettings) => {
    try {
      const { data, status } = await focusBearApi.put<PortfolioSettings>(
        Endpoints.PORTFOLIO_SETTINGS,
        payload
      );
      if (status === HTTP_STATS_CODE.SUCCESS) {
        toast.success(t(PORTFOLIO_I18N_KEYS.settingsSaved));
        return data;
      }
      toast.error(t(PORTFOLIO_I18N_KEYS.couldNotSaveSettings));
      return null;
    } catch (error) {
      toast.error(t('could_not_process_the_request'));
      captureException(JSON.stringify(error));
      return null;
    }
  }
);
